import { render, staticRenderFns } from "./XzdListPage.vue?vue&type=template&id=aff2b416&scoped=true"
import script from "./XzdListPage.vue?vue&type=script&lang=js"
export * from "./XzdListPage.vue?vue&type=script&lang=js"
import style0 from "./XzdListPage.vue?vue&type=style&index=0&id=aff2b416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff2b416",
  null
  
)

export default component.exports